/**
 * RFC 7807 problem `type` URIs for applicant business errors. Match on these
 * via `getApiError(error)` instead of parsing `detail`. Mirrors the backend
 * `App\Applicant\Enum\ApplicantErrorType`.
 */
export const ApplicantErrorType = {
  AccessDenied: '/errors/applicant-access-denied',
  Duplicate: '/errors/applicant-duplicate',
  PassInterimCreditsExhausted: '/errors/passinterim-credits-exhausted'
} as const

export type ApplicantErrorType =
  (typeof ApplicantErrorType)[keyof typeof ApplicantErrorType]
